import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import Button from 'src/app/atoms/Button/Button';

const MightyProLinkTextBlock = (): JSX.Element => (
  <Stack
    margin={['spacing-none', 'spacing-auto']}
    maxWidth='width-xl'
  >
    <Typography
      type='heading'
      size='sm'
      as='p'
      textAlign='center'
      display='inline'
      fontWeight='font-weight-semibold'
    >
      Upgrade to branded apps and put your name in the App Store with
      <Button
        href='/pro'
        variant='brand-text-link'
        display='inline'
      >
        {' '}
        Mighty Pro
      </Button>
      .
    </Typography>
  </Stack>
);

export default MightyProLinkTextBlock;
